import React from "react";
import { withTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import styles from "./SearchWrapper.module.scss";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HasPermissionTo from "../../../common/HasPermissionTo";

const DisplaySearchType = (props) => {
  return (
    <Grid item md={3} xs={6}>
      <div className={styles.searchType}>
        <div>
          <div className={styles.searchTitle}>{props.header}</div>
          <div className={styles.searchText}>
            {props.desc ? props.desc : "--"}
          </div>
          <Link
            className={styles.link}
            data-testid={props.name}
            to={props.link}
            name={props.name}
          >
            <div className={styles.goto}>
              {props.goto}
              <ChevronRightIcon className={styles.rightChevron} />
            </div>
          </Link>
        </div>
      </div>
    </Grid>
  );
};

function SearchWrapper(props) {
  return (
    <HasPermissionTo
      perform={["searchLandingPage"]}
      permissions={props.user.permissions.rolePermissions}
      condition={props.user.hasNscCompletedBasicPAs}
      render={() => (
        <div className="pageWrapper" id="SearchWrapper">
          <div className={`${styles.titleDiv} pagePadding`}>
            <div className="pageTitle">
              {props.t("SearchWrapper.title")}
            </div>
          </div>
          <p className={`${styles.subHeader} pagePadding`}>
            {props.t("SearchWrapper.subTitle")}
          </p>

          <Grid container className={styles.search} spacing={0}>
            <DisplaySearchType
              header={props.t("SearchWrapper.ordersSearch")}
              desc={props.t("SearchWrapper.ordersSearchDesc")}
              goto={props.t("SearchWrapper.gotoPage")}
              link="/search/orders"
              name="orders"
            />
          </Grid>
        </div>
      )}
    />
  );
}

export default withTranslation("emp")(SearchWrapper);
